"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fieldContainerAttributes = exports.selectAttributes = exports.textareaAttributes = exports.inputAttributes = exports.conditionalAttributes = exports.commonAttributes = exports.helperAttributes = exports.selectArrowAttrs = exports.iconAttributes = exports.warningMsgAttributes = exports.errorMsgAttributes = exports.counterAttributes = exports.labelAttributes = void 0;

var _fieldAttrsUtils = _interopRequireWildcard(require("../microFields/fieldAttrsUtils"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

// Pass-through base functions
var labelAttributes = _fieldAttrsUtils.labelAttributes;
exports.labelAttributes = labelAttributes;
var counterAttributes = _fieldAttrsUtils.counterAttributes;
exports.counterAttributes = counterAttributes;
var errorMsgAttributes = _fieldAttrsUtils.errorMsgAttributes;
exports.errorMsgAttributes = errorMsgAttributes;
var warningMsgAttributes = _fieldAttrsUtils.warningMsgAttributes;
exports.warningMsgAttributes = warningMsgAttributes;
var iconAttributes = _fieldAttrsUtils.iconAttributes;
exports.iconAttributes = iconAttributes;
var selectArrowAttrs = _fieldAttrsUtils.selectArrowAttrs;
exports.selectArrowAttrs = selectArrowAttrs;
var helperAttributes = _fieldAttrsUtils.helperAttributes; // Adapted functions

/**
 * Generate common html attributes for fields
 * @param  {Object}  atts - standard html attributes to include
 * @param  {Object}  field - the formik field object
 * @param  {boolean} isRequiredField - whether the field should be marked as required
 * @param  {boolean} isInvalid - whether the field should be marked as invalid
 * @return {Object} common html attributes for fields <input> <select> <textarea>
 */

exports.helperAttributes = helperAttributes;

var commonAttributes = function commonAttributes(_ref) {
  var atts = _ref.atts,
      field = _ref.field,
      isRequiredField = _ref.isRequiredField,
      isInvalid = _ref.isInvalid;
  return _fieldAttrsUtils.commonAttributes({
    fieldName: field.name,
    atts: atts,
    isRequiredField: isRequiredField,
    isInvalid: isInvalid,
    field: field
  });
};
/**
 * Generate conditional html attributes for fields
 * @param {Object} field - the formik field object
 * @param {String} label - value of the label for the field
 * @param {String} [helper=''] - (optional) help text that would be provided for the field
 * @param {boolean} [isInvalid=false] - (optional) whether the field should be marked as invalid
 * @return {Object} conditional html attributes for fields <input> <select> <textarea>
 */


exports.commonAttributes = commonAttributes;

var conditionalAttributes = function conditionalAttributes(_ref2) {
  var field = _ref2.field,
      label = _ref2.label,
      _ref2$helper = _ref2.helper,
      helper = _ref2$helper === void 0 ? '' : _ref2$helper,
      _ref2$isInvalid = _ref2.isInvalid,
      isInvalid = _ref2$isInvalid === void 0 ? false : _ref2$isInvalid;
  return _fieldAttrsUtils.conditionalAttributes({
    fieldName: field.name,
    label: label,
    helper: helper,
    isInvalid: isInvalid
  });
};
/**
 * Generate html attributes for <input>
 * @param  {Object}  atts - standard html attributes to include
 * @param  {Object}  field - the formik field object
 * @param  {String}  label - value of the label for the field
 * @param  {String}  [helper] - (optional) help text that would be provided for the field
 * @param  {boolean} isRequiredField - whether the field should be marked as required
 * @param  {boolean} [isInvalid=false] - (optional) whether the field should be marked as invalid
 * @return {Object} html attributes (varies)
 */


exports.conditionalAttributes = conditionalAttributes;

var inputAttributes = function inputAttributes(_ref3) {
  var atts = _ref3.atts,
      field = _ref3.field,
      label = _ref3.label,
      helper = _ref3.helper,
      isRequiredField = _ref3.isRequiredField,
      _ref3$isInvalid = _ref3.isInvalid,
      isInvalid = _ref3$isInvalid === void 0 ? false : _ref3$isInvalid;
  return _fieldAttrsUtils.inputAttributes({
    fieldName: field.name,
    atts: atts,
    label: label,
    helper: helper,
    isRequiredField: isRequiredField,
    isInvalid: isInvalid,
    field: field
  });
};
/**
 * Generate html attributes for <textarea>
 * @param {Object}  atts - standard html attributes to include
 * @param {Object}  field - the formik field object
 * @param {String}  label - value of the label for the field
 * @param {boolean} isRequiredField - whether the field should be marked as required
 * @param {boolean} isPlastic - whether the current Gift Card item is plastic or not
 * @param {String}  [helper=''] - (optional) help text that would be provided for the field
 * @param {boolean} [isInvalid=false] (optional) whether the field should be marked as invalid
 * @return {Object} html attributes (varies)
 */


exports.inputAttributes = inputAttributes;

var textareaAttributes = function textareaAttributes(_ref4) {
  var atts = _ref4.atts,
      field = _ref4.field,
      label = _ref4.label,
      isRequiredField = _ref4.isRequiredField,
      isPlastic = _ref4.isPlastic,
      _ref4$helper = _ref4.helper,
      helper = _ref4$helper === void 0 ? '' : _ref4$helper,
      _ref4$isInvalid = _ref4.isInvalid,
      isInvalid = _ref4$isInvalid === void 0 ? false : _ref4$isInvalid;
  return _fieldAttrsUtils.textareaAttributes({
    fieldName: field.name,
    atts: atts,
    label: label,
    isRequiredField: isRequiredField,
    isPlastic: isPlastic,
    helper: helper,
    isInvalid: isInvalid,
    field: field
  });
};
/**
 * Generate html attributes for <select>
 * @param {Object}  field - the formik field object
 * @param {String}  label - value of the label for the field
 * @param {boolean} isRequiredField - whether the field should be marked as required
 * @param {boolean} isInvalid - whether the field should be marked as invalid
 * @param {boolean} isCentered - whether the field is centered or not
 * @param {boolean} transparent - whether the field border is transparent or not
 * @param {Object}  [atts={}] - (optional) standard html attributes to include
 * @param {string}  [helper=''] - (optional) help text that would be provided for the field
 * @return {Object} html attributes (varies)
 */


exports.textareaAttributes = textareaAttributes;

var selectAttributes = function selectAttributes(_ref5) {
  var field = _ref5.field,
      label = _ref5.label,
      isRequiredField = _ref5.isRequiredField,
      isInvalid = _ref5.isInvalid,
      isCentered = _ref5.isCentered,
      transparent = _ref5.transparent,
      _ref5$atts = _ref5.atts,
      atts = _ref5$atts === void 0 ? {} : _ref5$atts,
      _ref5$helper = _ref5.helper,
      helper = _ref5$helper === void 0 ? '' : _ref5$helper;
  return _fieldAttrsUtils.selectAttributes({
    fieldName: field.name,
    label: label,
    isRequiredField: isRequiredField,
    isInvalid: isInvalid,
    isCentered: isCentered,
    transparent: transparent,
    atts: atts,
    helper: helper,
    field: field
  });
};
/**
 * Generate html attributes for fieldContainer
 * @param  {Object}  field - the formik field object
 * @param  {boolean} [isSmall=false] - (optional) whether the field should be a smaller variant
 * @param  {String}  cashbotName - @see getCashbotAttrs
 * @param  {Object}  [cashbotOptions={}] - (optional) @see getCashbotAttrs
 * @return {Object}  html attributes for the field <div> containing element (className & cashbot-id)
 */


exports.selectAttributes = selectAttributes;

var fieldContainerAttributes = function fieldContainerAttributes(_ref6) {
  var field = _ref6.field,
      _ref6$isSmall = _ref6.isSmall,
      isSmall = _ref6$isSmall === void 0 ? false : _ref6$isSmall,
      cashbotName = _ref6.cashbotName,
      _ref6$cashbotOptions = _ref6.cashbotOptions,
      cashbotOptions = _ref6$cashbotOptions === void 0 ? {} : _ref6$cashbotOptions;
  return _fieldAttrsUtils.fieldContainerAttributes({
    fieldName: field.name,
    isSmall: isSmall,
    cashbotName: cashbotName,
    cashbotOptions: cashbotOptions
  });
};

exports.fieldContainerAttributes = fieldContainerAttributes;